import { usePunditUserContext } from "@circle-react/contexts";

export const useIsChatSpaceExportEnabled = () => {
  const { currentCommunitySettings, isLoading } = usePunditUserContext();

  return !!(!isLoading && currentCommunitySettings?.chat_space_export_enabled);
};
